export const checkoutRoutes = {
  default: '/agendar-consulta/pagamento',
  invalid: '/agendar-consulta/pagamento-invalido',
  success: '/agendar-consulta/pagamento-efetivado',
};
